"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const emailServiceProviders_1 = require("./emailServiceProviders");
const users_1 = require("./users");
exports.emailCampaignDetailData = graphql_tag_1.default `
  fragment emailCampaignDetailData on EmailCampaign {
    id
    name
    list {
      id
      name
      espId
    }
    segment {
      id
      name
      espId
    }
    testList {
      id
      name
      espId
    }
    createdAt
    updatedAt
    fromName
    fromEmail
    replyToEmail
    salesforceSendClassification {
      ...salesforceSendClassificationData
    }
    defaultSubjectLine
    resourceUrl
    conversions {
      id
      name
    }
    email {
      id
      emailNumber
    }
    creatingUser {
      ...basicUserDetailData
    }
    emailServiceProvider {
      ...campaignMonitorDetailData
      ...mailchimpDetailData
      ...mailjetDetailData
      ...sailthruDetailData
      ...salesforceListData
      ...activeCampaignDetailData
    }
  }
  ${emailServiceProviders_1.campaignMonitorDetailData}
  ${emailServiceProviders_1.mailchimpDetailData}
  ${emailServiceProviders_1.mailjetDetailData}
  ${emailServiceProviders_1.sailthruDetailData}
  ${emailServiceProviders_1.salesforceListData}
  ${users_1.basicUserDetailData}
  ${emailServiceProviders_1.salesforceSendClassificationData}
  ${emailServiceProviders_1.activeCampaignDetailData}
`;
exports.emailCampaignListData = graphql_tag_1.default `
  fragment emailCampaignListData on EmailCampaign {
    id
    createdAt
    updatedAt
  }
`;
//# sourceMappingURL=emailCampaigns.js.map